import { EventBus } from "mvc-kit";
// src/modules/AuthWrapper2/events/AuthEvents.ts
var AuthEventBus = class extends EventBus {};
export { AuthEventBus };

//# sourceMappingURL=AuthEvents.js.map